import { Component } from '@angular/core';
import { ShimmerFragmentLibComponent } from '../fragment/shimmer-fragment.component';

@Component({
  selector: 'lib-loading-initial-screen',
  standalone: true,
  imports: [ShimmerFragmentLibComponent],
  templateUrl: './screen.component.html',
  styleUrls: ['./screen.component.scss'],
})
export class ScreenLoadingComponent {}
